import ErrorState from '@rio-cloud/rio-uikit/ErrorState';
import { FormattedMessage } from 'react-intl';

import type { MessageKey } from '../../../../configuration';

interface Props {
    headline: MessageKey;
    onReload: () => void;
}

export default function LoadingErrorStateWithReload(props: Props) {
    return (
        <ErrorState
            headline={<FormattedMessage id={props.headline} />}
            buttons={[
                {
                    text: (
                        <span>
                            <FormattedMessage id={'intl-msg:marketplace.error.button.reload'} />
                        </span>
                    ),
                    onClick: props.onReload,
                },
            ]}
        />
    );
}
